import React from "react";
import OrderTableColumnsType from "@/scenes/OrderManagement/enum/OrderTableColumnsType";
import OrderTableColumnsTypeNameMap from "@/scenes/OrderManagement/map/OrderTableColumnsTypeNameMap";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

interface StatusHeadProps {}

const StatusHead: React.FC<StatusHeadProps> = React.memo(function (props) {
    const orderManagementStore = useOrderManagementStore();

    // function showOrderTagSelect(e: { preventDefault: () => void }) {
    //     e.preventDefault();

    //     if (!orderManagementStore.table.isShowMoreOptions) {
    //         orderManagementStore.table.toggleMoreSearchOptions();
    //     }

    //     setTimeout(() => {
    //         const targetButton = document.querySelector(".order-tag-form-select");

    //         if (!targetButton) {
    //             return;
    //         }

    //         // 创建点击事件
    //         const event = new MouseEvent("click", {
    //             bubbles: true,
    //         });

    //         targetButton.dispatchEvent(event);
    //     }, 16);
    // }

    return (
        <th>
            <div
                className="status-head-container"
                style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}
            >
                <span>{OrderTableColumnsTypeNameMap[OrderTableColumnsType.STATUS]}</span>

                {/* <a href="#" onClick={showOrderTagSelect}>
                    搜索
                </a> */}
            </div>
        </th>
    );
});

export default StatusHead;
